import styled from '@emotion/styled';
import React from 'react';
import StyledSkewedSection from './skewed-section';
import { StyledH1, StyledH2 } from './_shared/styled-headings';
import Skillstech from './skillstech';

const StyledLogoSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const StyledFactNumber = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  & > .number {
    margin-left: 2rem;
    margin-bottom: 1rem;
    font-size: 2rem;
    font-weight: bold;
  }

  & > .fact {
    position: relative;
    text-transform: uppercase;
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
    background-color: var(--bg-color);
    margin-left: 2rem;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: -2rem;
      width: 1rem;
      height: 2px;
      background-color: var(--primary-color);
    }
  }
`;

const Facts = () => {
  return (
    <div id="skillssss">
      <StyledSkewedSection angle={10}>
        <StyledH1>Skill Set</StyledH1>

        <StyledLogoSection>
          <StyledFactNumber>
            <span className="fact">Frontend</span>
            <Skillstech
              techs={[
                'React.js',
                'Next.js',
                'JavaScript (ES6+)',
                'TypeScript',
                'Redux',
                'Redux-toolkit',
                'Zustand',
                'React-Query',
                'WebPack',
                'Apollo Client',
                'GraphQL',
                'CSS3',
                `SCSS`,
                'Shadcn',
                `Tailwind CSS`,
                'BootStrap',
                'Material UI',
                'HTML5',
              ]}
            />
          </StyledFactNumber>
          <StyledFactNumber>
            <span className="fact">Backend</span>
            <Skillstech
              techs={['Node.js', 'Express.js', `GraphQL`, 'RESTful API', 'PostgreSQL', 'MongoDB', 'Drizzle ORM']}
            />
          </StyledFactNumber>
          <StyledFactNumber>
            <span className="fact">Others</span>
            <Skillstech
              techs={[
                'GIT',
                'Data Structures',
                'Algorithms',
                'PWA',
                'Chrome-Extensions',
                'Python',
                'C/C++',
                'Linux Os',
                'Shell Scripting',
                'PostMan',
              ]}
            />
          </StyledFactNumber>
        </StyledLogoSection>
      </StyledSkewedSection>
    </div>
  );
};

export default Facts;
